var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadRoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1015_15617)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50107 15.1503C-0.251469 13.1746 -0.0619279 10.7646 1.33772 8.68595C5.39037 2.66674 15.378 2.18975 19.0783 8.39053C22.4502 14.0409 17.8067 16.8983 13.4507 17.5255C9.14647 18.1448 3.69303 17.6211 1.50164 15.1508L1.50107 15.1503Z",
    fill: "#F5A13E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50103 15.1498C1.22668 14.8407 1.00185 14.5203 0.817996 14.1936C0.814581 14.1873 0.813442 14.185 0.811166 14.181C0.80832 14.1759 0.797505 14.1623 0.802628 14.1657C6.83037 18.3509 18.9587 15.4782 19.9542 10.29C21.3465 14.6888 17.287 16.9718 13.4501 17.5245C9.14585 18.1438 3.69242 17.6201 1.50103 15.1498Z",
    fill: "#E8902C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5377 11.1355C16.6494 9.83493 16.3597 8.3778 15.2344 7.18989C11.9763 3.75026 4.87848 4.01722 2.66261 7.99985C0.643119 11.629 4.11405 13.1101 7.23721 13.2484C10.3234 13.3856 14.1478 12.7623 15.5383 11.1355H15.5377Z",
    fill: "#FAAE57"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2645 8.10619C11.8195 7.56887 11.6635 6.97919 11.0858 6.50562C9.4135 5.13386 5.81962 5.29836 4.72221 6.93365C3.72214 8.4238 5.49005 8.99811 7.07298 9.02999C8.63712 9.06129 10.5707 8.77783 11.2651 8.10619H11.2645Z",
    fill: "#FFBC70"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26561 6.80098C3.84897 6.68088 3.4124 7.14534 3.70325 7.22047C3.92979 7.2791 4.18081 7.15388 4.33221 6.98995C4.39881 6.91823 4.5098 6.89888 4.48988 6.84708C4.46768 6.79073 4.38401 6.83513 4.26561 6.80098Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23583 6.74238C3.81918 6.62228 3.38261 7.08674 3.67347 7.16188C3.90001 7.2205 4.15102 7.09528 4.30242 6.93135C4.36902 6.85964 4.48001 6.84028 4.46009 6.78849C4.43789 6.73214 4.35422 6.77653 4.23583 6.74238Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81068 6.99119C3.87386 6.94907 3.90915 6.89158 3.8898 6.86255C3.87044 6.83409 3.80385 6.8449 3.74067 6.88702C3.67749 6.92914 3.6422 6.98663 3.66155 7.01566C3.6809 7.04412 3.7475 7.03331 3.81068 6.99119Z",
    fill: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54461 8.47223C6.31693 8.10282 5.68171 8.15234 5.84621 8.40336C5.97428 8.59916 6.24407 8.67543 6.46663 8.65608C6.56453 8.64754 6.65958 8.70844 6.67894 8.65608C6.70057 8.59916 6.60893 8.57582 6.54404 8.47109L6.54461 8.47223Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56228 8.40965C6.3346 8.04025 5.69938 8.08977 5.86445 8.34135C5.99251 8.53658 6.26231 8.61342 6.48487 8.59407C6.58277 8.58553 6.67782 8.64644 6.69717 8.59407C6.7188 8.53715 6.62716 8.51382 6.56228 8.40908V8.40965Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08038 8.30751C6.15551 8.31889 6.2204 8.30011 6.22552 8.26596C6.23064 8.2318 6.17372 8.19481 6.09859 8.18399C6.02346 8.17261 5.95857 8.19139 5.95345 8.22554C5.94832 8.2597 6.00524 8.29669 6.08038 8.30751Z",
    fill: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47985 6.9243C5.70752 6.5549 6.34274 6.60442 6.17825 6.856C6.05018 7.05123 5.78038 7.12807 5.55783 7.10872C5.45992 7.10018 5.36487 7.16109 5.34552 7.10872C5.32389 7.0518 5.41553 7.02846 5.48042 6.92373L5.47985 6.9243Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46186 6.8609C5.68954 6.49149 6.32476 6.54101 6.15969 6.79203C6.03162 6.98783 5.76183 7.0641 5.53927 7.04475C5.44137 7.03621 5.34631 7.09711 5.32696 7.04532C5.30533 6.9884 5.39697 6.96506 5.46186 6.86033V6.8609Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94429 6.75868C5.86916 6.77006 5.80427 6.75128 5.79915 6.71713C5.79403 6.68298 5.85095 6.64598 5.92608 6.63516C6.00121 6.62378 6.0661 6.64256 6.07122 6.67672C6.07635 6.71087 6.01943 6.74786 5.94429 6.75868Z",
    fill: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17338 5.49813C5.57978 5.34616 6.05108 5.77419 5.76705 5.87209C5.5462 5.94837 5.28551 5.84306 5.12215 5.69166C5.05044 5.62506 4.93773 5.61482 4.95367 5.56188C4.97132 5.50383 5.0584 5.54139 5.17338 5.49813Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19877 5.43661C5.60461 5.28464 6.07647 5.71267 5.79244 5.81057C5.57159 5.88684 5.3109 5.78154 5.14754 5.63014C5.07583 5.56354 4.96313 5.5533 4.97906 5.50036C4.99671 5.4423 5.08379 5.47987 5.19877 5.43661Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64192 5.65194C5.57589 5.61494 5.53605 5.5603 5.55256 5.53013C5.56963 5.49996 5.6368 5.50565 5.70282 5.54265C5.76885 5.57965 5.80869 5.63429 5.79219 5.66446C5.77511 5.69463 5.70794 5.68893 5.64192 5.65194Z",
    fill: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52765 5.66435C7.26525 5.31942 6.63743 5.43041 6.8264 5.66435C6.97268 5.84649 7.24931 5.89601 7.46845 5.85503C7.56464 5.83681 7.66539 5.88861 7.68019 5.83454C7.69613 5.77591 7.60221 5.76168 7.52822 5.66378L7.52765 5.66435Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53888 5.59892C7.27648 5.25399 6.64866 5.36498 6.83763 5.59892C6.98392 5.78106 7.26054 5.83058 7.47968 5.7896C7.57588 5.77138 7.67662 5.82261 7.69142 5.76911C7.70736 5.71048 7.61344 5.69625 7.53945 5.59835L7.53888 5.59892Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0494 5.54556C7.12511 5.54955 7.18829 5.5245 7.18999 5.48978C7.1917 5.45506 7.13137 5.42432 7.05567 5.42034C6.97996 5.41635 6.91678 5.4414 6.91507 5.47612C6.91337 5.51084 6.9737 5.54158 7.0494 5.54556Z",
    fill: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61608 4.74078C8.84375 4.37138 9.47897 4.4209 9.31448 4.67191C9.18641 4.86771 8.91661 4.94398 8.69406 4.92463C8.59616 4.91609 8.5011 4.977 8.48175 4.9252C8.46012 4.86828 8.55176 4.84495 8.61608 4.74021V4.74078Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5985 4.67731C8.82618 4.3079 9.46139 4.35742 9.2969 4.60843C9.16883 4.80424 8.89903 4.88051 8.67648 4.86116C8.57858 4.85262 8.48352 4.91352 8.46417 4.86116C8.44254 4.80424 8.53418 4.7809 8.59907 4.67617L8.5985 4.67731Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08101 4.57509C9.00588 4.58647 8.94099 4.56769 8.93587 4.53353C8.93074 4.49938 8.98766 4.46239 9.0628 4.45157C9.13793 4.44019 9.20282 4.45897 9.20794 4.49312C9.21306 4.52727 9.15614 4.56427 9.08158 4.57509H9.08101Z",
    fill: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48046 7.10762C8.06381 6.98752 7.62724 7.45198 7.9181 7.52711C8.14463 7.58574 8.39565 7.46052 8.54705 7.29659C8.61365 7.22487 8.72464 7.20552 8.70472 7.15372C8.68252 7.09737 8.59885 7.14177 8.48046 7.10762Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45067 7.04887C8.03402 6.92934 7.59745 7.39323 7.88831 7.46837C8.11485 7.52699 8.36586 7.40177 8.51727 7.23784C8.58386 7.16612 8.69486 7.14677 8.67494 7.09498C8.65274 7.03863 8.56907 7.08302 8.45067 7.04887Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02552 7.29783C8.0887 7.25571 8.12399 7.19822 8.10464 7.16919C8.08529 7.14073 8.01869 7.15154 7.95551 7.19366C7.89233 7.23578 7.85704 7.29327 7.87639 7.3223C7.89575 7.35076 7.96234 7.33995 8.02552 7.29783Z",
    fill: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18737 5.91161C9.41504 5.5422 10.0503 5.59172 9.88576 5.8433C9.7577 6.03854 9.4879 6.11538 9.26534 6.09603C9.16744 6.08749 9.07239 6.14839 9.05304 6.09659C9.03141 6.03968 9.12305 6.01634 9.18793 5.91161H9.18737Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16979 5.8482C9.39746 5.4788 10.0327 5.52832 9.86819 5.77933C9.74012 5.97513 9.47032 6.05141 9.24777 6.03205C9.14987 6.02352 9.05481 6.08442 9.03546 6.03205C9.01383 5.97513 9.10547 5.9518 9.16979 5.84707V5.8482Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65181 5.74598C9.57668 5.75737 9.51179 5.73858 9.50667 5.70443C9.50155 5.67028 9.55846 5.63328 9.63303 5.62247C9.70816 5.61109 9.77305 5.62987 9.77817 5.66402C9.78329 5.69817 9.72638 5.73517 9.65124 5.74598H9.65181Z",
    fill: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49277 8.8603C9.83201 8.58993 10.4132 8.85233 10.173 9.03277C9.98626 9.17336 9.70622 9.154 9.50359 9.06009C9.41479 9.01911 9.30437 9.04415 9.30323 8.98837C9.30209 8.92747 9.39658 8.93657 9.49277 8.8603Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49766 8.79487C9.8369 8.5245 10.418 8.7869 10.1778 8.96734C9.99115 9.10793 9.7111 9.08857 9.50847 8.99466C9.41968 8.95368 9.30925 8.97872 9.30812 8.92294C9.30698 8.86204 9.40146 8.87114 9.49766 8.79487Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98623 8.86239C9.91167 8.84759 9.85703 8.80774 9.86386 8.77416C9.87069 8.74058 9.93671 8.72521 10.0107 8.74001C10.0853 8.75481 10.1399 8.79465 10.1331 8.82824C10.1263 8.86239 10.0602 8.87719 9.98623 8.86239Z",
    fill: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.242 7.54728C11.0821 7.14429 10.448 7.08225 10.5664 7.35831C10.6586 7.5729 10.9108 7.69584 11.1333 7.71519C11.2312 7.72373 11.3137 7.80057 11.3422 7.75276C11.3735 7.7004 11.287 7.66169 11.2415 7.54728H11.242Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2708 7.48869C11.1109 7.0857 10.4768 7.02366 10.5952 7.29972C10.6874 7.5143 10.9396 7.63725 11.1621 7.6566C11.26 7.66514 11.3425 7.74198 11.3716 7.69417C11.4029 7.6418 11.3164 7.6031 11.2708 7.48869Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8136 7.30408C10.8853 7.32799 10.953 7.32116 10.9638 7.28815C10.9746 7.2557 10.9251 7.2096 10.8534 7.18512C10.7817 7.16122 10.714 7.16805 10.7031 7.20106C10.6923 7.23407 10.7418 7.27961 10.8136 7.30408Z",
    fill: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1957 5.9304C11.4837 5.60596 12.1013 5.76533 11.8952 5.98447C11.7353 6.15466 11.4558 6.18369 11.2407 6.12563C11.1462 6.10058 11.0415 6.14384 11.0312 6.0892C11.0198 6.02944 11.1143 6.02204 11.1957 5.9304Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1894 5.86472C11.4775 5.54085 12.0945 5.69966 11.889 5.9188C11.729 6.08898 11.4496 6.11801 11.2338 6.05995C11.1394 6.03491 11.0346 6.07817 11.0244 6.02353C11.013 5.96376 11.1075 5.95636 11.1889 5.86472H11.1894Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6819 5.84842C11.6062 5.84615 11.5453 5.81655 11.5464 5.7824C11.5475 5.74768 11.6096 5.72149 11.6853 5.72377C11.761 5.72548 11.8219 5.75565 11.8208 5.7898C11.8196 5.82452 11.7576 5.8507 11.6819 5.84842Z",
    fill: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9897 4.46935C12.416 4.39023 12.8059 4.89397 12.5094 4.94064C12.2789 4.97707 12.0404 4.82851 11.9055 4.65092C11.8463 4.57294 11.737 4.54335 11.7626 4.49383C11.7905 4.43975 11.8691 4.49212 11.9903 4.46935H11.9897Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0249 4.41369C12.4512 4.33457 12.8411 4.8383 12.5445 4.88498C12.314 4.92141 12.0755 4.77285 11.9406 4.59526C11.8814 4.51728 11.7722 4.48768 11.7978 4.43816C11.8251 4.38409 11.9042 4.43645 12.0254 4.41369H12.0249Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4243 4.70267C12.3656 4.65485 12.336 4.59395 12.3577 4.5672C12.3793 4.54045 12.4447 4.55809 12.5034 4.6059C12.562 4.65428 12.5916 4.71462 12.57 4.74137C12.5483 4.76812 12.4829 4.75048 12.4243 4.70267Z",
    fill: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1938 6.67207C12.7772 6.55197 12.3406 7.01643 12.6315 7.09156C12.858 7.15019 13.109 7.02497 13.2604 6.86104C13.327 6.78932 13.4386 6.76997 13.4181 6.71817C13.3959 6.66182 13.3122 6.70622 13.1938 6.67207Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1645 6.61348C12.7479 6.49338 12.3113 6.95784 12.6022 7.03297C12.8281 7.0916 13.0797 6.96638 13.2311 6.80245C13.2977 6.73073 13.4087 6.71138 13.3888 6.65958C13.3666 6.60323 13.2829 6.64763 13.1645 6.61348Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7394 6.86326C12.8026 6.82114 12.8379 6.76365 12.8185 6.73462C12.7992 6.70616 12.7326 6.71697 12.6694 6.75909C12.6062 6.80121 12.5709 6.8587 12.5903 6.88773C12.6096 6.91619 12.6762 6.90538 12.7394 6.86326Z",
    fill: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1257 5.4867C14.7352 5.2983 14.2263 5.68193 14.5007 5.80488C14.7136 5.9005 14.9828 5.82025 15.1598 5.68364C15.2378 5.62387 15.3505 5.62387 15.3391 5.5698C15.3266 5.5106 15.2367 5.5402 15.1262 5.4867H15.1257Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1071 5.4242C14.7167 5.2358 14.2078 5.61943 14.4821 5.74238C14.695 5.838 14.9643 5.75718 15.1413 5.62114C15.2192 5.56137 15.3319 5.56137 15.3206 5.5073C15.308 5.4481 15.2181 5.4777 15.1077 5.4242H15.1071Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6452 5.59707C14.7146 5.56633 14.759 5.51568 14.7448 5.4838C14.7306 5.45249 14.6628 5.45193 14.594 5.48266C14.5245 5.5134 14.4801 5.56406 14.4944 5.59593C14.5086 5.62724 14.5763 5.62781 14.6452 5.59707Z",
    fill: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.139 8.26396C14.8766 7.91903 14.2488 8.03002 14.4377 8.26396C14.584 8.4461 14.8606 8.49562 15.0798 8.45464C15.176 8.43642 15.2767 8.48765 15.2915 8.43415C15.3075 8.37552 15.2135 8.36129 15.1395 8.26339L15.139 8.26396Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1502 8.19853C14.8878 7.8536 14.26 7.96459 14.449 8.19853C14.5952 8.38067 14.8719 8.43019 15.091 8.38921C15.1872 8.37099 15.288 8.42222 15.3027 8.36872C15.3187 8.31009 15.2248 8.29586 15.1508 8.19796L15.1502 8.19853Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6607 8.14419C14.7364 8.14818 14.7995 8.12313 14.8012 8.08841C14.8029 8.05426 14.7432 8.02296 14.6669 8.01897C14.5912 8.01499 14.5286 8.04003 14.5269 8.07475C14.5252 8.10947 14.5849 8.14021 14.6607 8.14419Z",
    fill: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5196 7.28158C16.1975 6.99072 15.6015 7.21669 15.8303 7.41135C16.0079 7.56333 16.2885 7.56105 16.4969 7.48023C16.5879 7.44494 16.6967 7.47681 16.7006 7.42103C16.7058 7.3607 16.6107 7.36354 16.5196 7.28158Z",
    fill: "#D17D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5191 7.21615C16.197 6.92529 15.601 7.15126 15.8299 7.34592C16.0074 7.4979 16.2881 7.49562 16.4964 7.4148C16.5874 7.37951 16.6962 7.41081 16.7007 7.3556C16.7053 7.29527 16.6108 7.29811 16.5197 7.21615H16.5191Z",
    fill: "#FFE5B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0276 7.2528C16.1028 7.24256 16.1597 7.20613 16.1551 7.17198C16.1506 7.13783 16.0857 7.11847 16.0106 7.12872C15.9354 7.13896 15.8785 7.17539 15.8831 7.20954C15.8876 7.2437 15.9525 7.26305 16.0276 7.2528Z",
    fill: "#FFF3DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1015_15617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 13.812,
    fill: "white",
    transform: "translate(0.236328 3.95117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadRoll);
export default __webpack_public_path__ + "static/media/bread-roll.26bc2b4c6fb2822a91da67fa15407f1f.svg";
export { ForwardRef as ReactComponent };